import React from "react";

/**
 * タイトルを最大2行に収めるため、はみ出す場合はフォントサイズを段階的に縮小する。
 */
export function FitTwoLines({
  children,
  className,
  style,
  maxFontSize = 18,
  minFontSize = 10,
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  maxFontSize?: number
  minFontSize?: number
}) {
  const ref = React.useRef<HTMLDivElement>(null)
  const LINE_HEIGHT = 1.5

  React.useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    const fit = () => {
      let size = maxFontSize
      el.style.fontSize = `${size}px`
      while (size > minFontSize && el.scrollHeight > size * LINE_HEIGHT * 2 + 1) {
        size -= 1
        el.style.fontSize = `${size}px`
      }
    }
    fit()
    // 自身の高さは文字サイズで変わるため、幅変化の検知は親要素を監視する
    const parent = el.parentElement
    if (!parent || typeof ResizeObserver === "undefined") return
    const observer = new ResizeObserver(fit)
    observer.observe(parent)
    return () => observer.disconnect()
  }, [children, maxFontSize, minFontSize])

  return (
    <div ref={ref} className={className} style={{ ...style, lineHeight: LINE_HEIGHT }}>
      {children}
    </div>
  )
}
